import Model, {
  attr,
  hasMany,
  belongsTo,
  type SyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type UserModel from './user';
import type LocationModel from './location';
import type ItemModel from './item';

export default class CompanyModel extends Model {
  declare [Type]: 'company';
  @attr()
  declare name?: string;
  @attr()
  declare tax_number?: string;
  @attr()
  declare street?: string;
  @attr()
  declare street_number?: string;
  @attr()
  declare zip_code?: string;
  @attr()
  declare place?: string;
  @attr()
  declare contact_person?: string;
  @attr()
  declare telefon_number?: string;
  @attr()
  declare fax_number?: string;
  @attr()
  declare email?: string;
  @attr()
  declare mobile_number?: string;
  @attr()
  declare created_at?: string;
  @attr()
  declare updated_at?: string;

  @hasMany('user', { async: false, inverse: 'company' })
  declare users: SyncHasMany<UserModel>;
  @hasMany('location', { async: false, inverse: 'company' })
  declare locations: SyncHasMany<LocationModel>;
  @hasMany('item', { async: false, inverse: 'company' })
  declare items: SyncHasMany<ItemModel>;
  @belongsTo('location', { async: false, inverse: null })
  declare default_location: LocationModel | null;
}
